import useApiClient from "../../hooks/useApiClient";
import { useAuth } from "../../hooks/useAuth";
import { SignInCredentials } from "./auth.requests";
import { AuthResponse } from "./auth.responses";
import axios from "axios";
import { BASE_URL } from "../internal";

export const useAuthService = () => {
  const apiClient = useApiClient();
  const { accessToken } = useAuth();

  const signIn = (signInData: SignInCredentials) => {
    return apiClient.post<AuthResponse>("/auth/local/sign-in", signInData);
  };

  const logout = () => {
    // Use a plain axios call to avoid triggering the 401 interceptor,
    // which would attempt to refresh and cause an infinite loop
    return axios.patch(`${BASE_URL}/auth/logout`, null, {
      headers: { Authorization: `Bearer ${accessToken}` },
      withCredentials: true,
    });
  };

  return {
    signIn,
    logout,
  };
};

export default useAuthService;
